import React, { useEffect, useState, useRef } from "react";
import { useTranslation, Trans } from "react-i18next";
import { Carousel } from 'bootstrap';

import slide_1 from "../assets/images/slide_2_ouverture.png";
import slide_2 from "../assets/images/slide_2_ouverture.png";
import slide_3 from "../assets/images/slide_2_ouverture.png";
import slide_4 from "../assets/images/slide_2_ouverture.png";
import open_wash_door from "../assets/images/open_wash_door.png";
import choose_prog from "../assets/images/choose_prog.png";
import central_payment from "../assets/images/central_payment.png";
import after_washing from "../assets/images/after_washing.png";
import open_dry_door from "../assets/images/start_dry.png";
import dry_second from "../assets/images/dry_second.png";
import dry_last from "../assets/images/dry_last.png";
import {animateSmoothTransition, initializeCarouselProgress, triggerFadeInOnScroll} from "../assets/js/swithalert";
import config from "../config";
import Breadcrumb from "../components/Breadcrumb"

function Home() {

  const [progress, setProgress] = useState(0);
  const [intervalTime, setIntervalTime] = useState(5000); // Default to 5 seconds

  const { i18n, t } = useTranslation();


  useEffect(() => {
    const myCarouselEl = document.getElementById('home-carousel');
    if (myCarouselEl) {
      // This requires `import { Carousel } from 'bootstrap'` or the bundle
      const carousel = new Carousel(myCarouselEl, {
        interval: 5000,
        ride: 'carousel',
        pause: true,
      });
    }
    animateSmoothTransition();
    initializeCarouselProgress(setProgress, setIntervalTime);
    triggerFadeInOnScroll();
  }, []);

  return (
    <div className="main">
      <Breadcrumb />
      <div className="section_home_courousel">
          <div id="home-carousel" className="carousel slide">
            <div className="carousel-indicators">
              <button data-bs-target="#home-carousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
              <button data-bs-target="#home-carousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
              <button data-bs-target="#home-carousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
              <button data-bs-target="#home-carousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
            </div>
            <div className="carousel-inner">
              {/* Image Slide 1 */}
              <div className="carousel-item active overlay animated">
                <div className="container position-relative">
                  <img src= {slide_1} className="d-block w-100" alt="Drying Machines" />
                  <div className="carousel-message d-flex flex-column align-items-center">
                    <h2 className="text-color-light font-weight-extra-bold text-16 mb-4 mb-sm-6 appear-animation" data-appear-animation="blurIn" data-plugin-options="{'minWindowWidth': 0}">
                      {t("home_carousel_title_1")}
                    </h2>
                    <p className="text-8 text-color-light font-weight-light mt-0 mt-sm-4 opacity-7 text-center mb-2 mb-sm-4" data-plugin-animated-letters="" data-plugin-options="{'startDelay': 1000, 'minWindowWidth': 0, 'animationSpeed': 25}">
                      {t("home_carousel_text_1")}
                    </p>
                  </div>
                </div>
              </div>

              {/* Image Slide 2 */}
              <div className="carousel-item overlay">
              <div className="container position-relative">
                  <img src= {slide_2} className="d-block w-100" alt="Drying Machines" />
                  <div className="carousel-message d-flex flex-column align-items-center">
                    <h2 className="text-color-light font-weight-extra-bold text-16 mb-0 mb-sm-6 appear-animation" data-appear-animation="blurIn" data-plugin-options="{'minWindowWidth': 0}">
                      {t("home_carousel_title_2")}
                    </h2>
                    <p className="text-8 text-color-light font-weight-light mt-0 mt-sm-4 opacity-7 text-center mb-2 mb-sm-4" data-plugin-animated-letters="" data-plugin-options="{'startDelay': 1000, 'minWindowWidth': 0, 'animationSpeed': 25}">
                      {t("home_carousel_text_2")}
                    </p>
                  </div>
                </div>
              </div>

              {/* Image Slide 3 */}
              <div className="carousel-item overlay">
              <div className="container position-relative">
                  <img src= {slide_3} className="d-block w-100" alt="Drying Machines" />
                  <div className="carousel-message d-flex flex-column align-items-center">
                    <h2 className="text-color-light font-weight-extra-bold text-16 mb-0 mb-sm-6 appear-animation" data-appear-animation="blurIn" data-plugin-options="{'minWindowWidth': 0}">
                      {t("home_carousel_title_3")}
                    </h2>
                    <p className="text-8 text-color-light font-weight-light mt-0 mt-sm-4 opacity-7 text-center mb-2 mb-sm-4" data-plugin-animated-letters="" data-plugin-options="{'startDelay': 1000, 'minWindowWidth': 0, 'animationSpeed': 25}">
                      {t("home_carousel_text_3")}
                    </p>
                  </div>
                </div>
              </div>

              {/* Image Slide 4 */}
              <div className="carousel-item overlay">
              <div className="container position-relative">
                  <img src= {slide_4} className="d-block w-100" alt="Drying Machines" />
                  <div className="carousel-message d-flex flex-column align-items-center">
                    <h2 className="text-color-light font-weight-extra-bold text-16 mb-0 mb-sm-6 appear-animation" data-appear-animation="blurIn" data-plugin-options="{'minWindowWidth': 0}">
                    {t("home_carousel_title_4")}
                    </h2>
                    <p className="text-8 text-color-light font-weight-light mt-0 mt-sm-4 opacity-7 text-center mb-2 mb-sm-4" data-plugin-animated-letters="" data-plugin-options="{'startDelay': 1000, 'minWindowWidth': 0, 'animationSpeed': 25}">
                      {t("home_carousel_text_4")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-progress-bar">
              <div className="progress" style={{ width: `${progress}%` }}></div>
            </div>
          </div>
      </div>
      <div class="section_home_pride animated" data-aos="">
        <div class="subtitle">
          <div class="rect col-sm-4 col-4 my-auto pt-sm-4 pt-4">
            <span class="bar"></span>
            <span class="bar"></span>
            <span class="bar"></span>
            <span class="bar"></span>
          </div>           
          <h2 class="">{t("home_pride_title")}</h2>
        </div> 
        <div class="content">
          <p class="">{t("home_pride_content_1")} <br/>{t("home_pride_content_2")}</p>
        </div>
      </div>
      <div class="section_home_wash animated" data-aos="">
            <div class="subtitle">
              <div class="rect col-sm-4 col-4 my-auto pt-sm-4 pt-2">
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span> 
              </div>
              <h2 class="pb-2">{t("home_wash_title")}</h2>        
            </div>
            <div class="content d-grid d-md-flex justify-content-center">
              <div class="carding one mx-2 mx-xl-4 mt-md-4 border-bottom">
                <div class="wrapper">
                  <img src={open_wash_door}/>
                </div>
                <p class="px-1">{t("home_wash_content_1")}</p>
              </div>
              <div class="carding two mx-2 mx-xl-4 mt-4 mt-sm-4 border-bottom">
                <div class="wrapper">
                  <img src={choose_prog}/>
                </div>
                <p class="px-1">{t("home_wash_content_2")}</p>
              </div>
              <div class="carding three mx-2 mx-xl-4 mt-4 mt-sm-4 border-bottom">
                <div class="wrapper">
                  <img src={central_payment}/>
                </div>
                <p class="px-1">{t("home_wash_content_3")}</p>
              </div>
              <div class="carding four mx-2 mx-xl-4 mt-4 mt-sm-4 border-bottom">
                <div class="wrapper">
                  <img src={after_washing}/>
                </div>
                <p class="px-1">{t("home_wash_content_4")}</p>
              </div>
            </div>
      </div>
      <div class="section_home_dry animated" data-aos="">
            <div class="subtitle">
              <div class="rect col-sm-4 col-4 my-auto pt-sm-4 pt-2">
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span> 
              </div>
              <h2 class="pb-2">{t("home_dry_title")}</h2>        
            </div>
            <div class="content d-grid  d-md-flex justify-content-center">
              <div class="carding one mx-2 mx-xl-4 mt-md-4 border-bottom">
                <div class="wrapper">
                  <img src={open_dry_door}/>
                </div>
                <p class="px-1">{t("home_dry_content_1")}</p>
              </div>
              <div class="carding two mx-2 mx-xl-4 mt-4 mt-sm-4 border-bottom">
                <div class="wrapper">
                  <img src={dry_second}/>
                </div>
                <p class="px-1">{t("home_dry_content_2")}</p>
              </div>
              <div class="carding three mx-2 mx-xl-4 mt-4 mt-sm-4 border-bottom">
                <div class="wrapper">
                  <img src={central_payment}/>
                </div>
                <p class="px-1">{t("home_dry_content_3")}</p>
              </div>
              <div class="carding four mx-2 mx-xl-4 mt-4 mt-sm-4 border-bottom">
                <div class="wrapper">
                  <img src={dry_last}/>
                </div>
                <p class="px-1">{t("home_dry_content_4")}</p>
              </div>
            </div>
      </div>
      <div class="section_home_creation" data-aos="">
      <div class="subtitle">
        <div class="rect col-sm-4 col-4 my-auto pt-sm-4 pt-4">
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </div>           
        <h2 class="">
        <Trans i18nKey="home_creation_title" 
            values={{ brand: config.brand}}>
        </Trans>
        </h2>
      </div> 
      <div class="content">
        <p class="">
          <Trans i18nKey="home_creation_content" 
              values={{ brand: config.brand}}>
          </Trans>
        </p>
        <div class="row">
          <div class="col-md-6 left text-start">
            <h3>
              <Trans i18nKey="home_creation_subtitle_1" 
                values={{ brand: config.brand}}>
            </Trans>
            </h3>
            <ul class="list list-icons list-icons-style-3">
              <li class="row"><i class="fas fa-check col-2"> </i> <strong class="col-10"> {t("home_creation_left_text_1")} </strong></li>
              <li class="row"><i class="fas fa-check col-2"> </i> <strong class="col-10"> {t("home_creation_left_text_2")} </strong></li>
              <li class="row"><i class="fas fa-check col-2"> </i> <strong class="col-10"> {t("home_creation_left_text_3")} </strong></li>
              <li class="row"><i class="fas fa-check col-2"> </i> <strong class="col-10"> {t("home_creation_left_text_4")} </strong></li>
              <li class="row"><i class="fas fa-check col-2"> </i> <strong class="col-10"> {t("home_creation_left_text_5")} </strong></li>
              <li class="row"><i class="fas fa-check col-2"> </i> <strong class="col-10"> {t("home_creation_left_text_6")} </strong></li>
              <li class="row"><i class="fas fa-check col-2"> </i> <strong class="col-10"> {t("home_creation_left_text_7")} </strong></li>
            </ul>
          </div>
          <div class="col-md-6 right text-start">
            <h3>
              <Trans i18nKey="home_creation_subtitle_2" 
                  values={{ brand: config.brand}}>
              </Trans>
            </h3>
              <ul class="list list-icons list-icons-style-3">
              <li class="row"><i class="fas fa-check col-2"> </i> <strong class="col-10"> {t("home_creation_right_text_1")} </strong></li>
              <li class="row"><i class="fas fa-check col-2"> </i> <strong class="col-10"> {t("home_creation_right_text_2")} </strong></li>
              <li class="row"><i class="fas fa-check col-2"> </i> <strong class="col-10"> {t("home_creation_right_text_3")} </strong></li>
              <li class="row"><i class="fas fa-check col-2"> </i> <strong class="col-10">{t("home_creation_right_text_4")}</strong></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
      

      

    </div>
  );
}

export default Home;
